declare let THREE: any;
import { WallSize } from './wall-size';
import { TextureUtilsService } from '../services/texture-utils.service';
import { ImageUtilsService } from '../services/image-utils.service';
import { UnitsManagerService } from '../services/units-manager.service';

export class Line extends (THREE.Line as { new(): any; }) {

    constructor(private textureUtils: TextureUtilsService,
        private imageUtils: ImageUtilsService,
        private unitsManager: UnitsManagerService) {
        super();
        var material = new THREE.LineBasicMaterial({
            color: 0x000000
        });

        var geometry = new THREE.Geometry();
        geometry.vertices.push(
            new THREE.Vector3(0, 0, 0),
            new THREE.Vector3(1, 0, 0)
        );

        THREE.Line.call(this, geometry, material);

        this.add(new WallSize(textureUtils, imageUtils, unitsManager));
        // console.log('line');
    }

    updateLength(length) {
        var geometry = this.geometry;
        var size = this.getObjectByName('size');
        geometry.vertices[1].x = length;
        geometry.verticesNeedUpdate = true;
        size.update();
        size.visible = true;
    }

    //need for wall size to work
    getSize() {
        return {
            length: this.geometry.vertices[1].x
        }
    }

    getEndPoint() {
        this.updateMatrixWorld();
        return this.localToWorld(new THREE.Vector3(this.geometry.vertices[1].x, 0, 0));
    }

}



// WEBPACK FOOTER //
// ./src/app/custom/line.ts